import { Card as ChakraCard } from '@chakra-ui/react'

/**
 * Card Component
 * Wrapper around Chakra UI Card with compound components (v3)
 */
export function Card({ header, children, footer, ...props }) {
  return (
    <ChakraCard.Root { ...props }>
      {header && <ChakraCard.Header>{ header }</ChakraCard.Header>}
      <ChakraCard.Body>{ children }</ChakraCard.Body>
      {footer && <ChakraCard.Footer>{ footer }</ChakraCard.Footer>}
    </ChakraCard.Root>
  )
}

// Export compound components for direct use
export const CardBody = ChakraCard.Body
export const CardFooter = ChakraCard.Footer
export const CardHeader = ChakraCard.Header

export default Card
